import { render, staticRenderFns } from "./CommonModalWithMaterialTypeEditor.vue?vue&type=template&id=7790b652&lang=pug&"
import script from "./CommonModalWithMaterialTypeEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonModalWithMaterialTypeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonModalWithMaterialTypeEditor.vue?vue&type=style&index=0&id=7790b652&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports